module.exports = __webpack_public_path__ + "img/video.e15b3643.png";